import { normalize, schema } from "normalizr";

export const normalizeCardArray = (originalCards) => {
  const cardsSchema = new schema.Entity("cards");

  const cards = new schema.Array(cardsSchema);

  return normalize(originalCards, cards);
};
